import { _, helpers, React, ts, ui } from '_core';

import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  file: string;
  factors: string[];
  fullScreen: boolean;
  title: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
};

const Chart = ({ id, loadWidgetData, readOnly, file, factors = [], fullScreen, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: file,
        },
      });

      if (response) setData(response.data);
    } catch (err) {
      setError(JSON.stringify(err));
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    const filteredData = !factors.includes('risk_model')
      ? data.filter((el) => factors.includes(el.category as string) || factors.includes(el.type as string))
      : data;
    return nestedBarChartFormat(filteredData, 'category');
  }, [data, factors]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      category="category"
      numberFormat="#.##%"
      yAxisLabel="Percent Significance"
      tooltipText="[bold]{category}:[/] {valueY}"
      rotation={90}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};

export default Chart;
